var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuickStartPortfolio(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.84375 3.10938V6.9375H25.1562V3.10938C25.1562 2.2207 24.4043 1.46875 23.5156 1.46875H11.4844C10.5273 1.46875 9.84375 2.2207 9.84375 3.10938ZM8.75 6.9375V3.10938C8.75 1.60547 9.91211 0.375 11.4844 0.375H23.5156C25.0195 0.375 26.25 1.60547 26.25 3.10938V6.9375H30.625C33.0176 6.9375 35 8.91992 35 11.3125V18.4219V28.8125C35 31.2734 33.0176 33.1875 30.625 33.1875H4.375C1.91406 33.1875 0 31.2734 0 28.8125V18.4219V11.3125C0 8.91992 1.91406 6.9375 4.375 6.9375H8.75ZM1.09375 18.9688V28.8125C1.09375 30.6582 2.5293 32.0938 4.375 32.0938H30.625C32.4023 32.0938 33.9062 30.6582 33.9062 28.8125V18.9688H22.9688V22.25C22.9688 23.4805 21.9434 24.4375 20.7812 24.4375H14.2188C12.9883 24.4375 12.0312 23.4805 12.0312 22.25V18.9688H1.09375ZM12.0312 17.875H13.125H21.875H22.9688H33.9062V11.3125C33.9062 9.53516 32.4023 8.03125 30.625 8.03125H25.7031H9.29688H4.375C2.5293 8.03125 1.09375 9.53516 1.09375 11.3125V17.875H12.0312ZM13.125 18.9688V22.25C13.125 22.8652 13.6035 23.3438 14.2188 23.3438H20.7812C21.3281 23.3438 21.875 22.8652 21.875 22.25V18.9688H13.125Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuickStartPortfolio);
export default __webpack_public_path__ + "static/media/quick_start_portfolio.005babffb0cce71d5168c145c8c3f9bb.svg";
export { ForwardRef as ReactComponent };